import { type Dispatch, type SetStateAction } from 'react'
import { IconButton } from 'shared/ui'

export const PreviewStar = ({
  index,
  activeStar,
  onClick,
}: {
  index: number
  activeStar: number
  onClick: Dispatch<SetStateAction<number>>
}) => {
  const starNumber = index + 1

  return (
    <IconButton
      icon={'starFilled1'}
      variant={'transparent'}
      iconProps={{
        fontSize: 36,
        color: activeStar >= starNumber ? 'var(--yellow-70)' : 'var(--gray-30)',
      }}
      onClick={() => {
        onClick(starNumber)
      }}
      ariaLabel={`star${starNumber}`}
    />
  )
}
